import type { ReactNode } from 'react';

export const symbol_movie_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24.75 17.63-42.38Q115.25-800 140-800h20l212 212H140v368h600l60 60H140Zm725-21-45-45v-362H458L246-800h78l58 119q8 15 22 24t31 9q32.46 0 49.23-27.5Q501-703 487-732l-33-68h130l58 119q7.73 15.4 22.08 24.2Q678.44-648 695-648q32.5 0 49.25-27.46T747-732l-33-68h106q24 0 42 18t18 42v520.16q0 10.84-4 20.84t-11 18Zm-73 98L82-792q-9-9.07-9-21.53Q73-826 82.05-835q9.06-9 21.5-9 12.45 0 21.45 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83ZM470-404Zm169-3Z"
		/>
	</svg>
);
